/**
 * Polyfills for older browsers
 * Add necessary polyfills to support features in IE11 and other legacy browsers
 */

// Object.entries polyfill
if (!Object.entries) {
	Object.entries = function (obj) {
		var ownProps = Object.keys(obj),
			i = ownProps.length,
			resArray = new Array(i);
		while (i--) resArray[i] = [ownProps[i], obj[ownProps[i]]];

		return resArray;
	};
}

// Promise polyfill
if (typeof Promise === 'undefined') {
	console.warn('Promise polyfill should be loaded for older browsers');
	// A full Promise polyfill would be imported from a library like es6-promise
}

// Element.closest polyfill
if (!Element.prototype.closest) {
	Element.prototype.closest = function (s) {
		var el = this;
		do {
			if (
				el.matches(el.matchesSelector || el.msMatchesSelector || el.webkitMatchesSelector) &&
				el.matches(s)
			)
				return el;
			el = el.parentElement || el.parentNode;
		} while (el !== null && el.nodeType === 1);
		return null;
	};
}
